export const defaultLocale = 'en';
//# sourceMappingURL=default-locale.js.map